import { getImageThumbnailUrl } from '@/utils/getImageThumbnailUrl';
import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ReactImageMagnify from 'react-image-magnify';
import { DEFAULT_IMAGE_OBJECT, MEDIA_TYPES } from '../../../../utils/constants';

import {
  DesktopComponentContainer,
  DesktopComponentMainImageContainer,
  MainImageVideoIconContainer,
  SideImagePanelContainer,
  SidePanelImage,
  SidePanelLastMask,
  SidePanelLastMaskContainer,
  ShareActionsContainer,
  MagnifyImageContainer,
  ShareIconContainer,
  ShareOptionsContainer,
  SharOptionsBlock,
  SharOptionsSection,
  PortalContainer,
} from './DesktopImageComponent.styles';
import { PlayIcon } from '@/assets/svgExports/PlayIcon';
import { ShareIcon } from '@/assets/svgExports/ShareIcon';
import {
  copyTextToClipboard,
  generateFacebookShareURL,
  generateTelegramShareLink,
  generateTwitterWebIntentURL,
  generateWhatsAppShareURL,
} from '../../../../utils/generateShareableURLS';
import { getSrcSetFromCompressedImages } from '../../../../utils/compressedImagesHelpers';
import { SHARE_OPTIONS, SIDE_PANEL_MAX_IMAGE_LIMIT } from './constants';
import {
  getPlayIconPosition,
  getImageDimensions,
  getThumbnailImageDimensions,
  getEnlargedImageContainerDimensions,
  getZoomedImageDimension,
} from './utils';

function DesktopImageComponent(props) {
  const {
    theme: { product_aspect_ratio: aspectRatio, custom_theme_flag: customThemeFlag },
  } = useSelector((state) => ({
    theme: state.storeReducer.store.theme,
  }));
  const imageDimensions = getImageDimensions(aspectRatio, customThemeFlag);
  const enlargedImageContainerDimensions = getEnlargedImageContainerDimensions(
    aspectRatio,
    customThemeFlag
  );
  const thumbnailImageDimensions = getThumbnailImageDimensions(
    aspectRatio,
    customThemeFlag
  );
  const zoomedImageDimensions = getZoomedImageDimension(aspectRatio, customThemeFlag);
  const playIconPosition = getPlayIconPosition(aspectRatio, customThemeFlag);

  const { handleShowImageDescriptionModal, productData, activeIdx } = props;
  const [sidePanelImages, setSidePanelImages] = useState([]);
  const [mainImage, setMainImage] = useState();

  const [selectedVariant, setSelectedVariant] = useState(
    productData?.variants?.[activeIdx] || {}
  );

  const imageRef = useRef();
  const shareRef = useRef();

  useEffect(() => {
    handleSidePanelImages();
  }, [productData, selectedVariant]);

  useEffect(() => {
    !!sidePanelImages?.length && setMainImage(sidePanelImages[0]);
  }, [sidePanelImages]);

  useEffect(() => {
    if (activeIdx !== -1) setSelectedVariant(productData?.variants?.[activeIdx]);
  }, [activeIdx]);

  useEffect(() => {
    imageRef?.current?.getElementsByTagName('img')?.[0].setAttribute('property', 'image');
  }, [productData?.name]);

  useEffect(() => {
    props?.setMainImageIndexFromPdp(
      sidePanelImages.findIndex((item) => item?.image_url === mainImage?.image_url)
    );
  }, [mainImage]);
  useEffect(() => {
    const handler = (e) => {
      if (shareRef.current && !shareRef.current.contains(e.target)) {
        setShowAction(false);
      }
    };
    document.addEventListener('click', handler);
    return () => {
      document.removeEventListener('click', handler);
    };
  });

  function handleSidePanelViewMore() {
    if (mainImage?.image_url === DEFAULT_IMAGE_OBJECT.image_url) return;
    handleShowImageDescriptionModal();
  }

  function setImagesifVariantNotPresent() {
    if (!productData?.images?.length) {
      setSidePanelImages([DEFAULT_IMAGE_OBJECT]);
    } else {
      setSidePanelImages(productData?.images);
    }
  }

  function setImagesifVariantPresent() {
    if (productData?.variants?.length) {
      let tempImages = !!selectedVariant?.images
        ? selectedVariant?.images.slice(0, SIDE_PANEL_MAX_IMAGE_LIMIT)
        : [];
      if (productData?.images && productData?.images?.length) {
        if (tempImages?.length) tempImages = tempImages.concat(productData?.images);
        else tempImages = productData?.images?.slice(0, productData?.images?.length);
      }
      if (!tempImages?.length) tempImages?.push(DEFAULT_IMAGE_OBJECT);
      setSidePanelImages(tempImages);
    } else {
      const tempImages = productData?.images?.slice(0, productData?.images?.length);
      setSidePanelImages(tempImages);
    }
  }

  function handleSidePanelImages() {
    if (!productData?.variants_count) {
      setImagesifVariantNotPresent();
    } else {
      setImagesifVariantPresent();
    }
  }

  function handleSidePanelImage(item) {
    if (item?.media_type === MEDIA_TYPES?.VIDEO) {
      handleShowImageDescriptionModal();
    }
    setMainImage(item);
  }

  function handleMainImageView(item) {
    if (item?.media_type === MEDIA_TYPES?.VIDEO) {
      return getImageThumbnailUrl(item);
    }
    return item?.image_url;
  }
  const [showAction, setShowAction] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const handleParentEvent = (e) => {
    e.stopPropagation();
  };
  const handleShareButtonAction = (e) => {
    setShowAction((state) => !state);
    setIsCopied(false);
  };
  const handleShareOptionAction = (choice) => {
    switch (choice) {
      case 'Copy Link':
        copyTextToClipboard(window.location.href, setIsCopied);
        break;
      case 'Facebook':
        {
          const url = generateFacebookShareURL(
            window.location.href,
            productData?.name,
            choice
          );
          window.open(url);
        }
        break;
      case 'Whatsapp':
        {
          const url = generateWhatsAppShareURL(
            window.location.href,
            productData?.name,
            choice
          );
          window.open(url);
        }
        break;
      case 'Twitter':
        {
          const url = generateTwitterWebIntentURL(
            window.location.href,
            productData?.name,
            choice
          );
          window.open(url);
        }
        break;
      case 'Telegram': {
        const url = generateTelegramShareLink(
          window.location.href,
          productData?.name,
          choice
        );
        window.open(url);
      }
      default:
        console.error('Please Select a valid option');
    }
  };
  return (
    <DesktopComponentContainer isCustomWebsite={customThemeFlag}>
      <SideImagePanelContainer>
        {!!sidePanelImages?.length &&
          sidePanelImages.slice(0, SIDE_PANEL_MAX_IMAGE_LIMIT).map((item, index) => {
            return (
              <div
                className="relative"
                key={`${item?.image_id}-${index}-index-side-panel-images`}
              >
                <SidePanelImage
                  thumbnailImageDimensions={thumbnailImageDimensions}
                  src={getImageThumbnailUrl(item, false)}
                  isSelected={
                    mainImage?.thumbnail_url === item?.thumbnail_url ? true : false
                  }
                  onClick={() => {
                    handleSidePanelImage(item);
                  }}
                />
                {item?.media_type === MEDIA_TYPES.VIDEO && (
                  <div
                    className="absolute"
                    onClick={() => {
                      handleSidePanelImage(item);
                    }}
                    style={{
                      top: '40%',
                      left: playIconPosition,
                      transform: 'translate(-50%, -50%)',
                    }}
                  >
                    <PlayIcon />
                  </div>
                )}
              </div>
            );
          })}
        {sidePanelImages?.length > SIDE_PANEL_MAX_IMAGE_LIMIT && (
          <SidePanelLastMaskContainer
            thumbnailImageDimensions={thumbnailImageDimensions}
            onClick={handleSidePanelViewMore}
          >
            <SidePanelLastMask thumbnailImageDimensions={thumbnailImageDimensions}>
              + {sidePanelImages?.length - SIDE_PANEL_MAX_IMAGE_LIMIT}
            </SidePanelLastMask>
            <SidePanelImage src={sidePanelImages[0]?.image_url}></SidePanelImage>
          </SidePanelLastMaskContainer>
        )}
      </SideImagePanelContainer>
      <DesktopComponentMainImageContainer
        ref={imageRef}
        isCustomWebsite={customThemeFlag}
        imageDimensions={imageDimensions}
        mediaType={mainImage?.media_type}
        onClick={handleSidePanelViewMore}
      >
        <MagnifyImageContainer>
          <ShareActionsContainer ref={shareRef} onClick={handleParentEvent}>
            <ShareIconContainer onClick={handleShareButtonAction}>
              <ShareIcon />
            </ShareIconContainer>
            {showAction && (
              <ShareOptionsContainer>
                {SHARE_OPTIONS.map(({ id, portal, logo }, idx) => (
                  <SharOptionsBlock
                    key={id}
                    lastIdx={idx + 1 === SHARE_OPTIONS.length ? SHARE_OPTIONS.length : ''}
                  >
                    <SharOptionsSection onClick={() => handleShareOptionAction(portal)}>
                      <img src={logo} />
                      <PortalContainer
                        portal={
                          portal === 'Copy Link' && isCopied ? 'Link Copied' : portal
                        }
                      >
                        {portal === 'Copy Link' && isCopied ? 'Link Copied' : portal}
                      </PortalContainer>
                    </SharOptionsSection>
                  </SharOptionsBlock>
                ))}
              </ShareOptionsContainer>
            )}
          </ShareActionsContainer>
          <ReactImageMagnify
            {...{
              smallImage: {
                alt: mainImage?.alt_text || productData?.name,
                src: handleMainImageView(mainImage),
                srcSet: getSrcSetFromCompressedImages(
                  mainImage?.compressed_images,
                  handleMainImageView(mainImage)
                ),
                isFluidWidth: true,
              },
              largeImage: {
                src: handleMainImageView(mainImage),
                ...zoomedImageDimensions,
              },
              enlargedImageContainerDimensions,
              enlargedImageContainerStyle: {
                backgroundColor: '#ffffff',
                zIndex: 5,
                marginLeft: 42,
                boxShadow: '0 0 24px rgba(0,0,0,0.34)',
                borderRadius: 16,
                display:
                  mainImage?.image_url === DEFAULT_IMAGE_OBJECT.image_url ? 'none' : '',
              },
              enlargedImageStyle: {
                objectFit: 'cover',
                maxWidth: 1000,
                display:
                  mainImage?.image_url === DEFAULT_IMAGE_OBJECT.image_url ? 'none' : '',
              },
              lensStyle: {
                display:
                  mainImage?.image_url === DEFAULT_IMAGE_OBJECT.image_url ? 'none' : '',
              },
              shouldUsePositiveSpaceLens: true,
            }}
          />
        </MagnifyImageContainer>
        {mainImage?.media_type === MEDIA_TYPES.VIDEO && (
          <MainImageVideoIconContainer>
            <PlayIcon height={64} width={64} />
          </MainImageVideoIconContainer>
        )}
      </DesktopComponentMainImageContainer>
    </DesktopComponentContainer>
  );
}

export default DesktopImageComponent;
